export function chord(event) {
  const parts = [];
  const modified = event.ctrlKey || event.metaKey || event.altKey;
  const printable = event.key.length === 1;

  if (event.ctrlKey || event.metaKey) parts.push('ctrl');
  if (event.altKey) parts.push('alt');
  if (event.shiftKey && (modified || !printable)) parts.push('shift');

  parts.push(event.key.toLowerCase());

  return parts.join('_');
}
